import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { UsersCollection } from './users.types';

export function usersBackend(): Backend<UsersCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    }, // FIXME: T50039 This endpoint doesn't appear to be ordered in the backend
    fetch: (authUid, ids, query, order) => ({
      endpoint: `users/0.1/users`,
      params: {
        users: ids,
        usernames: getQueryParamValue(query, 'username'),
        avatar: 'true',
        online_offline_details: 'true',
        status: 'true',
        support_status_details: 'true',
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
